import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import { useApplicationStandaloneStoreActions } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import { computed } from "@vue/composition-api";
export const useAssetFieldBindings = options => {
  const {
    bindApplication,
    makeFieldPathReactive
  } = useBindApplication();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentAssetPath = computed(() => {
    return `${currentApplicantPath.value}[assets][${options.assetIndex.value}]`;
  });
  const {
    TRANSFER_APPLICANT_FIELD_BY_PATH
  } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.TRANSFER_APPLICANT_FIELD_BY_PATH]);
  const assetType = bindApplication(makeFieldPathReactive(currentAssetPath, "[type]"), "");
  const assetDescription = bindApplication(makeFieldPathReactive(currentAssetPath, "[description]"), "");
  const assetAmount = bindApplication(makeFieldPathReactive(currentAssetPath, "[amount]"), 0);
  const assetOwner = computed({
    get() {
      return options.applicantIndex.value;
    },
    set(newApplicantIndex) {
      if (typeof newApplicantIndex !== "number") return;
      const sourcePath = currentApplicantPath.value + "[assets]";
      const applicantPath = newApplicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : `${APPLICATION_PATH.CO_APPLICANTS}[${newApplicantIndex - 1}]`;
      const targetPath = applicantPath + "[assets]";
      TRANSFER_APPLICANT_FIELD_BY_PATH({
        sourcePath,
        targetPath,
        sourceElementIndex: options.assetIndex.value
      });
    }
  });
  return {
    assetType,
    assetDescription,
    assetAmount,
    assetOwner
  };
};